<script lang="ts" setup>

  type Props = {
    displayFilterLink?: boolean
  }
  const props = defineProps<Props>()

  const emit = defineEmits<{
    (e: 'displayAll' | 'changeFilter'): void
  }>()

</script>

<template>
  <div class="c-no-result">
    <SvgIcon
      icon="no-result"
      :width="54"
      :height="54"
      :desktop-width="54"
      :desktop-height="54"
    />
    <p><span class="text">Aucun résultat ne correspond à vos critères de recherche…</span></p>
    <div class="links">
      <a
        v-if="props.displayFilterLink"
        href="javascript:void(0)"
        @click="() => emit('changeFilter')"
      >
        <span>MODIFIER MES CRITÈRES</span>
      </a>
      <a
        href="javascript:void(0)"
        @click="() => emit('displayAll')"
      >
        <span>AFFICHER TOUS LES GOLFS</span>
      </a>
    </div>
  </div>
</template>
<style scoped>
.c-no-result {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 4em;

  p {
    margin: 2em;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.25em;
      font-weight: 600;
    }
  }

  .text{
    text-align: center;
  }

  .links {
    display: flex;
    flex-direction: column;
    margin: 0 2em 4em;
    text-align: center;

    a {
      span {
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.25em;
        font-weight: normal;
        text-decoration: underline;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .links {
      margin: 0 4em;
    }
  }
}

</style>
